export default __webpack_public_path__ + "static/media/completedCardHolder.bc891a50.jpg";